import { toast } from 'react-toastify';

export const DEFAULT_TYPE = 'DEFAULT_TYPE';
export const INFO_TYPE = 'INFO_TYPE';
export const ERROR_TYPE = 'ERROR_TYPE';
export const SUCCESS_TYPE = 'SUCCESS_TYPE';
export const WARNING_TYPE = 'WARNING_TYPE';

const toastTypeSelector = (type = DEFAULT_TYPE) => {
  switch (type) {
    case INFO_TYPE:
      return toast.info;
    case ERROR_TYPE:
      return toast.error;
    case SUCCESS_TYPE:
      return toast.success;
    case WARNING_TYPE:
      return toast.warning;
    default:
      return toast;
  }
};

export const DEFAULT = 'DEFAULT';
export const BOT_CREATION = 'BOT_CREATION';
export const BOT_UPDATE = 'BOT_UPDATE';
export const BOT_DELETION = 'BOT_DELETION';
export const BOT_ERROR_GROUPS_GETTER = 'BOT_ERROR_GROUPS_GETTER';
export const BOT_ERRORS_DETAILS_GETTER = 'BOT_ERRORS_DETAILS_GETTER';
export const BOT_SET_FOLDER = 'BOT_SET_FOLDER';
export const BOT_SPEC_UPDATE = 'BOT_SPEC_UPDATE';
export const FUNCTION_CREATION = 'FUNCTION_CREATION';
export const FUNCTION_UPDATE = 'FUNCTION_UPDATE';
export const FUNCTION_DELETION = 'FUNCTION_DELETION';
export const MESSAGE_CREATION = 'MESSAGE_CREATION';
export const MESSAGE_UPDATE = 'MESSAGE_UPDATE';
export const MESSAGE_DELETION = 'MESSAGE_DELETION';
export const STORAGE_UPDATE = 'STORAGE_UPDATE';
export const VARIABLE_CREATION = 'VARIABLE_CREATION';
export const VARIABLE_UPDATE = 'VARIABLE_UPDATE';
export const VARIABLE_DELETION = 'VARIABLE_DELETION';
export const VARIABLE_DEALLOCATED = 'VARIABLE_DEALLOCATED';
export const FOLDER_DELETION = 'FOLDER_DELETION';
export const FOLDER_UPDATE = 'FOLDER_UPDATE';
export const INTEGRATION_CREATION = 'INTEGRATION_CREATION';
export const INTEGRATION_UPDATE = 'INTEGRATION_UPDATE';
export const INTEGRATION_DELETION = 'INTEGRATION_DELETION';
export const TEMPLATE_CREATION = 'TEMPLATE_CREATION';
export const TEMPLATE_UPDATE = 'TEMPLATE_UPDATE';
export const BOT_PUBLISHED = 'BOT_PUBLISHED';
export const BOT_PUBLISHED_UPDATE = 'BOT_PUBLISHED_UPDATE';

const messages = {
  DEFAULT: {
    ERROR_TYPE: 'Something went wrong, please try again',
    SUCCESS_TYPE: 'Done',
  },
  BOT_CREATION: {
    ERROR_TYPE: 'Something went wrong creating bot',
    SUCCESS_TYPE: 'Bot was successfully created',
  },
  BOT_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating bot',
    SUCCESS_TYPE: 'Bot was successfully updated',
  },
  BOT_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting bot',
    SUCCESS_TYPE: 'Bot was successfully deleted',
  },
  BOT_ERROR_GROUPS_GETTER: {
    ERROR_TYPE: 'Something went wrong getting the error groups',
    SUCCESS_TYPE: 'Error groups obtained',
  },
  BOT_ERRORS_DETAILS_GETTER: {
    ERROR_TYPE: 'Something went wrong getting the errors details',
    SUCCESS_TYPE: 'Errors details obtained',
  },
  BOT_SPEC_UPDATE: {
    ERROR_TYPE: 'Something went wrong saving your changes, please try again',
    SUCCESS_TYPE: 'SpecJson was successfully updated',
  },
  FUNCTION_CREATION: {
    ERROR_TYPE: 'Something went wrong creating function',
    SUCCESS_TYPE: 'Function was successfully created',
  },
  FUNCTION_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating function',
    SUCCESS_TYPE: 'Function was successfully updated',
  },
  FUNCTION_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting function',
    SUCCESS_TYPE: 'Function was successfully deleted',
  },
  MESSAGE_CREATION: {
    ERROR_TYPE: 'Something went wrong creating message',
    SUCCESS_TYPE: 'Message was successfully created',
  },
  MESSAGE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating message',
    SUCCESS_TYPE: 'Message was successfully updated',
  },
  MESSAGE_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting message',
    SUCCESS_TYPE: 'Message was successfully deleted',
  },
  STORAGE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating storage',
    SUCCESS_TYPE: 'Storage was successfully updated',
  },
  VARIABLE_CREATION: {
    ERROR_TYPE: 'Something went wrong creating variable',
    SUCCESS_TYPE: 'Variable was successfully created',
  },
  VARIABLE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating variable',
    SUCCESS_TYPE: 'Variable was successfully updated',
  },
  VARIABLE_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting variable',
    SUCCESS_TYPE: 'Variable was successfully deleted',
  },
  VARIABLE_DEALLOCATED: {
    ERROR_TYPE: 'Something went wrong deallocating variable',
    SUCCESS_TYPE: 'Variable was deallocated',
  },
  BOT_SET_FOLDER: {
    ERROR_TYPE: 'Something went wrong saving your changes, please try again',
    SUCCESS_TYPE: 'Botspec folder type saved',
  },
  FOLDER_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting the folder',
    SUCCESS_TYPE: 'Folder was successfully deleted',
  },
  FOLDER_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating the folder',
    SUCCESS_TYPE: 'Folder was successfully updated',
  },
  INTEGRATION_CREATION: {
    ERROR_TYPE: 'Something went wrong creating the integration',
    SUCCESS_TYPE: 'Integration was successfully created',
  },
  INTEGRATION_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating the integration',
    SUCCESS_TYPE: 'Integration was successfully updated',
  },
  INTEGRATION_DELETION: {
    ERROR_TYPE: 'Something went wrong deleting the integration',
    SUCCESS_TYPE: 'Integration was successfully deleted',
  },
  TEMPLATE_CREATION: {
    ERROR_TYPE: 'Something went wrong creating the template',
    SUCCESS_TYPE: 'Template was successfully created',
  },
  TEMPLATE_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating the template',
    SUCCESS_TYPE: 'Template was successfully updated',
  },
  BOT_PUBLISHED: {
    ERROR_TYPE: 'Something went wrong publishing the bot',
    SUCCESS_TYPE: 'Bot was successfully published',
  },
  BOT_PUBLISHED_UPDATE: {
    ERROR_TYPE: 'Something went wrong updating the published bot',
    SUCCESS_TYPE: 'Published bot was successfully updated',
  },
};

const toastDispacher = ({
  elementName,
  actionId = DEFAULT,
  position = toast.POSITION.BOTTOM_LEFT,
  texts,
  type,
}) => {
  const toastDispatch = toastTypeSelector(type);
  let message = texts(messages[actionId][type]);
  if (elementName) {
    message += `: ${elementName}`;
  }
  message += '.';
  toastDispatch(message, { position });
};

export default toastDispacher;
